import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function stringList(value) {
  if (!Array.isArray(value) || value.some((item) => typeof item !== "string")) {
    return { status: NOT_CONFIGURED, items: [] };
  }
  return { status: null, items: value };
}

function messagesView(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, messages: [] };
  }
  return {
    status: null,
    messages: Object.keys(value).map((key) => ({
      key,
      value: typeof value[key] === "string" ? value[key] : NOT_CONFIGURED,
    })),
  };
}

function windowsView(value) {
  if (!Array.isArray(value)) {
    return { status: NOT_CONFIGURED, windows: [] };
  }
  return {
    status: null,
    windows: value.map((item, index) => ({
      index,
      weekday: readField(item, "weekday"),
      startLocal: activationValueText(readField(item, "start_local")),
      endLocal: activationValueText(readField(item, "end_local")),
    })),
  };
}

export function roofingV2HandoffView(settings) {
  const handoff = settings && settings.handoff;
  const hours = handoff && handoff.operator_hours;
  const targets = stringList(handoff && handoff.targets);
  const triggers = stringList(handoff && handoff.triggers);
  const routes = stringList(handoff && handoff.escalation_routes);
  const messages = messagesView(handoff && handoff.messages);
  const windows = windowsView(hours && hours.windows);
  const alwaysOn = readField(hours, "always_on");
  return {
    targetsStatus: targets.status,
    targets: targets.items,
    triggersStatus: triggers.status,
    triggers: triggers.items,
    escalationRoutesStatus: routes.status,
    escalationRoutes: routes.items,
    messagesStatus: messages.status,
    messages: messages.messages,
    emergencyContactRef: activationValueText(readField(handoff, "emergency_contact_ref")),
    operatorContactRef: activationValueText(readField(handoff, "operator_contact_ref")),
    alwaysOn: alwaysOn === "" ? '""' : alwaysOn,
    windowsStatus: windows.status,
    windows: windows.windows,
  };
}

export function handoffDeadlineNotice() {
  return "No handoff processing start or deadline is available.";
}

export function handoffCancelNotice() {
  return "A handoff is not a takeover and does not cancel a visit.";
}

export function configuredListHeading(label, status, items) {
  if (status) {
    return `${label}: ${status}`;
  }
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) {
    return `${label}:`;
  }
  return null;
}
